import { Component, OnInit } from '@angular/core'
import { FormSearchComponent } from '../../../shared/components/form-search/form-search.component'
import { MatCard } from '@angular/material/card'
import { MatProgressBar } from '@angular/material/progress-bar'
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component'
import { TableListComponent } from '../../../shared/components/table-list/table-list.component'
import { OperationStatusCreateComponent } from '../../../features/operation/operation-status-create/operation-status-create.component'
import { AuthService } from '../../../core/services/auth/auth.service'
import { MatDialog } from '@angular/material/dialog'
import {
  PagedContactTypeResponse,
  SearchContactTypeModel,
} from '../../../core/models/contact-type.model'
import { OperationStatusService } from '../../../core/services/operation/operation-status/operation-status.service'
import { OperationStatusEditComponent } from '../../../features/operation/operation-status-edit/operation-status-edit.component'
import { MatPaginatorModule } from '@angular/material/paginator'
import { PageEvent } from '@angular/material/paginator'

@Component({
  selector: 'operation-status',
  imports: [
    FormSearchComponent,
    MatCard,
    MatProgressBar,
    PaginationComponent,
    TableListComponent,
    OperationStatusCreateComponent,
    MatPaginatorModule,
  ],
  templateUrl: './operation-status.component.html',
  styleUrl: './operation-status.component.scss',
  providers: [OperationStatusService, AuthService],
  standalone: true,
})
export class OperationStatusComponent implements OnInit {
  constructor(
    private operationStatusService: OperationStatusService,
    private authService: AuthService,
    private dialog: MatDialog,
  ) {}

  page: number = 1
  rows: number = 10
  numberRows: number = 0
  itemsList: any[] = []
  loading: boolean = false
  searchForm: SearchContactTypeModel = new SearchContactTypeModel()
  inputSearch: string = ''
  columns: any[] = [
    { keyColumn: 'code', key: 'id', description: 'Código' },
    {
      keyColumn: 'description',
      key: 'descricao',
      description: 'Descrição',
    },
    {
      keyColumn: 'action',
      key: { edit: false, delete: false },
      description: 'Ações',
    },
  ]
  screen: string = 'status operação'

  ngOnInit() {
    this.checkColumnAction()
    this.getListItems()
  }

  checkColumnAction() {
    let index = this.columns.findIndex((ele: any) => {
      return ele.keyColumn == 'action'
    })
    if (index != -1) {
      this.columns[index].key = {
        edit: this.checkPermission('editar'),
        delete: this.checkPermission('deletar'),
      }
      if (!Object.values(this.columns[index].key).includes(true)) {
        this.columns.splice(index, 1)
      }
    }
  }

  checkPermission(permission: string) {
    return this.authService.checkPermission(permission, this.screen)
  }

  search(event: any) {
    let search = event
    this.page = 1
    if (search) {
      this.searchForm.descricao = search
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  pageChanged(page: number) {
    this.page = page
    this.uploadList()
  }

  onPageEvent(event: PageEvent) {
    this.page = event.pageIndex + 1 // pageIndex é zero-based, a sua variável page é 1-based
    this.rows = event.pageSize
    this.uploadList()
  }

  pageSizeChanged(newPageSize: number) {
    this.rows = newPageSize
    this.page = 1 // normalmente reseta para a primeira página
    this.uploadList()
  }

  uploadList(type: string = '') {
    if (type == 'new') {
      this.searchForm = new SearchContactTypeModel()
    }
    if (this.searchForm.descricao) {
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  treatResponse(response: any) {
    let list = []
    if (response.data) {
      for (let item of response.data) {
        list.push(item)
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }

  getListItems() {
    this.loading = true
    this.operationStatusService
      .listPagedOperationStatus(this.page, this.rows)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loading = false
        },
      })
  }

  searchListItems() {
    this.loading = true
    this.operationStatusService
      .searchPagedOperationStatus(this.page, this.rows, this.searchForm)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loading = false
        },
      })
  }

  editItem(item: any) {
    const dialogRef = this.dialog.open(OperationStatusEditComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      data: item,
    })
    dialogRef.componentInstance.responseEdit.subscribe((response) => {
      if (response) {
        this.uploadList()
      }
    })
  }

  deleteItem(item: any) {
    console.log('item delete', item)
  }
}
